module.exports = __webpack_public_path__ + "img/horizontal_6_7_3009.6fafbca5.png";